<template>
    <img v-if="item.image && sessionStore.imgix" 
        :src="imgixSrc" 
        :srcset="imgixSrcset" 
        :alt="itemDesc" 
        sizes="(max-width: 468) 160px, (max-width: 415) 140px, (max-width: 365) 120px, 175px"
        height="175"
        width="175"
    />
    <img v-else-if="item.image && !sessionStore.imgix" :src="item.image" :alt="item.itemDesc" />
    <img v-else :src="`${baseUrl}/images/productPlaceholder.webp`" class="is-svg" :alt="`No Image for ${itemDesc}`" />
    <img v-if="item.isExclusiveBrand == 1" class="product-eb" :src="`${baseUrl}/images/EB-tag-grey.jpg`" alt="Exclusive Brand" />
</template>

<script setup>
    import { computed } from 'vue';
    import { useSessionStore } from "@/store/storeSession.js";

    const sessionStore = useSessionStore();

    const props = defineProps({
        item: {
            type: Object,
            required: true,
            default: () => ({
                itemDesc: '',
                image: '',
                isExclusiveBrand: 0,
            })
        },
        itemDesc: {
            type: String,
            required: false,
            default: '',
        }
    });

    const baseUrl = computed(() => {
        let baseUrl = window.location.origin;

        if (baseUrl.includes('.box')) {
            baseUrl = baseUrl.replace('.box', '.com');
        }

        return baseUrl;
    });

    const imgixBaseUrl = computed(() => {
        let imgixBaseUrl = '';

        if (props.item.image) {
            let isLocal = props.item.image.includes('/usf_items/') ? true : false;
            let imageBaseUrl = isLocal ? 'https://www.chefstore.com/images' : 'https://assets.usfoods.com/Product/Image';
            let usfBaseUrl = 'https://usfchefstore.imgix.net';
            let localBaseUrl = sessionStore.environment === 'PROD' ? 'https://chefstore.imgix.net' : 'https://chefstorestag.imgix.net';
            
            imgixBaseUrl = props.item.image.replace(imageBaseUrl, isLocal ? localBaseUrl : usfBaseUrl);
        }

        return imgixBaseUrl;
    });

    const imgixSrc = computed(() => {
        let imgixSrc = '';

        if (props.item.image) {
            imgixSrc = `${imgixBaseUrl.value}?w=175&h=175dpr=1&&fit=max&auto=compress,format${imgixParam(props.item.image)}`;
        }

        return imgixSrc;
    });

    const imgixSrcset = computed(() => {
        let imgixSrcset = '';

        if (props.item.image) {
            let imgixParamStr = imgixParam(props.item.image);
            imgixSrcset += `${imgixBaseUrl.value}?w=160&h=160&dpr=1&fit=max&auto=compress,format${imgixParamStr} 160w, `;
            imgixSrcset += `${imgixBaseUrl.value}?w=160&h=160&dpr=2&fit=max&auto=compress,format${imgixParamStr} 320w, `;
            imgixSrcset += `${imgixBaseUrl.value}?w=140&h=140&dpr=1&fit=max&auto=compress,format${imgixParamStr} 140w, `;
            imgixSrcset += `${imgixBaseUrl.value}?w=140&h=140&dpr=2&fit=max&auto=compress,format${imgixParamStr} 280w, `;
            imgixSrcset += `${imgixBaseUrl.value}?w=120&h=120&dpr=1&fit=max&auto=compress,format${imgixParamStr} 120w, `;
            imgixSrcset += `${imgixBaseUrl.value}?w=120&h=120&dpr=2&fit=max&auto=compress,format${imgixParamStr} 240w, `;
            imgixSrcset += `${imgixBaseUrl.value}?w=175&h=175&dpr=1&fit=max&auto=compress,format${imgixParamStr} 175w, `;
            imgixSrcset += `${imgixBaseUrl.value}?w=175&h=175&dpr=2&fit=max&auto=compress,format${imgixParamStr} 350w`;
        }

        return imgixSrcset;
    });

    function imgixParam(imagePath) {
        const validCsExt = ["jpg","jpeg","webp","avif","heic","heif"];
        const ext = imagePath.split(".").pop().toLowerCase();
        const imgixParam = validCsExt.includes(ext) ? '&cs=srgb' : '';

        return imgixParam;
    }

</script>

<style>

</style>